export const tabindex = {
  name: 'tabindex',

  mounted: (el) => {
    if (navigator.userAgent.indexOf('Firefox') > -1) {
      const contentId = el.getAttribute('href');

      document.querySelector(contentId)?.setAttribute('tabindex', '-1');
    }
  },
};
